import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetDefaultTask as GetDefaultTaskQuery,
    GetDefaultTask_taskDefaults as TaskDefaults,
} from 'nutshell-graphql-types';

import GET_DEFAULT_TASK from '../queries/get-default-task.graphql';

export const useGetDefaultTask = (): {
    defaultTask: TaskDefaults | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetDefaultTaskQuery, Record<any, any>>(
        GET_DEFAULT_TASK
    );

    return {
        defaultTask: data ? data.taskDefaults : null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
